module.exports = __webpack_public_path__ + "static/media/12.f631ec77.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/12.png
// module id = 694
// module chunks = 0